import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public _localStorage = signal<any>({});

  constructor() {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      this._localStorage.update((prev) => ({
        ...prev,
        [key]: localStorage.getItem(key),
      }));
    });
  }

  public getItem(key: string, parse?: boolean): string | undefined | any {
    const itemFound = this._localStorage()[key];
    if (itemFound) return parse ? JSON.parse(itemFound) : itemFound;
    return undefined;
  }

  public setItem(key: string, value: string) {
    localStorage.setItem(key, value);
    this._localStorage.update((data) => ({ ...data, [key]: value }));
  }

  public deleteItem(key: string) {
    const currentStorage = this._localStorage();
    delete currentStorage[key];
    this._localStorage.set(currentStorage);
    localStorage.removeItem(key);
  }
}
